// extracted by mini-css-extract-plugin
export default {"img":"NewsPage_img__Az+Iz"};